import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';
import { formatAsQueryParams } from 'utils/queryString';
import { getActualStage } from 'components/ProgramManagement/utils';
import {
  adminDashboardProgramsApi,
  PROGRAM_DASHBOARD_TAG,
} from 'services/apiSlices/programs/adminDashboardProgramsApi';
import { adminDashboardApi, DASHBOARD_TOTALS_TAG } from 'services/apiSlices/adminDashboardApi';

export const managementPanelApi = createApi({
  reducerPath: 'managementPanelApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/management-panel/',
  }),
  endpoints: builder => ({
    // Update Application
    updateApplicationBulk: builder.mutation({
      query: ({ query = {}, ...data }) => ({
        url: `members/${getActualStage(data.stage)}/bulk/?`,
        params: formatAsQueryParams(query, true), // Todo: test it applying filters in tables in PM Panel
        method: 'PATCH',
        data,
      }),
      // Moving a member between stages changes the admin dashboard's program counts,
      // which live in separate API slices with their own cache.
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(adminDashboardProgramsApi.util.invalidateTags([PROGRAM_DASHBOARD_TAG]));
          dispatch(adminDashboardApi.util.invalidateTags([DASHBOARD_TOTALS_TAG]));
        } catch {
          // Mutation failed, nothing to invalidate
        }
      },
    }),
    // /available-mentors
    getAvailableMentors: builder.query({
      query: ({ data }) => ({
        url: 'available-mentors',
        params: { ...data },
        method: 'GET',
      }),
    }),
    // Potential approach to the other enpoints witht he same base URL (not tested):
    // // Fetch program : programs/${id}
    // updateApplicationBulk: builder.query({
    //   query: ({ id }) => ({
    //     url: `programs/${id}`,
    //   }),
    // }),
    // // Update program: ${payload.id}/ + payload
    // updateApplicationBulk: builder.mutation({
    //   query: ({id, ...payload } ) => ({
    //     url: `programs/${id}`,
    //     params: formatAsQueryParams(query, true), // come back to this later
    //     method: "PATCH",
    //     body: payload,
    //   }),
    // }),
  }),
});

export const { useUpdateApplicationBulkMutation, useGetAvailableMentorsQuery } = managementPanelApi;
